import { BookingMockup } from "./BookingMockup";

const BENEFITS = [
  "Votre page de réservation en ligne en 2 minutes",
  "Synchronisation Google Agenda et rappels automatiques",
  "Seul ou en équipe : collectif, tournant, organisations",
];

/** Right-hand panel of the signup page: Calify promise + booking preview. */
export function SignupShowcase() {
  return (
    <div className="relative hidden overflow-hidden rounded-l-3xl bg-[#0B3022] px-12 py-14 text-white lg:flex lg:flex-col lg:justify-between">
      <div className="pointer-events-none absolute -right-24 -top-24 h-72 w-72 rounded-full bg-[#2F7D58]/30 blur-3xl" />
      <div className="pointer-events-none absolute -bottom-32 -left-16 h-80 w-80 rounded-full bg-[#C5D6C6]/10 blur-3xl" />
      <div className="relative">
        <img src="/calify-logo-white.svg" alt="Calify" className="h-8 w-auto" />
        <h2 className="font-cal mt-10 max-w-md text-4xl font-semibold leading-tight">
          Vos rendez-vous, <span className="text-[#9FD0B4]">sans les allers-retours.</span>
        </h2>
        <ul className="mt-8 space-y-3 text-[15px] text-[#DCE8E0]">
          {BENEFITS.map((benefit) => (
            <li key={benefit} className="flex items-start gap-3">
              <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-[#2F7D58] text-xs">
                ✓
              </span>
              {benefit}
            </li>
          ))}
        </ul>
      </div>
      <div className="relative mt-12 text-[#10231A]">
        <BookingMockup />
      </div>
      <p className="relative mt-12 text-xs text-[#9DB5A6]">Calify · développé par nodev</p>
    </div>
  );
}
